<template>
    <div>
        <div v-if="isUnderMaintenance == 0 || isUnderMaintenance == 1">
            <div class="text-center" style="font-family:Sans-serif">
                <center>
                    <v-overlay v-model="overlay">
                        <v-progress-circular
                            indeterminate
                            :size="120"
                            :width="3"
                        ></v-progress-circular><br>Loading, please wait...
                    </v-overlay>
                </center>
            </div>
            <!-- <v-dialog persistent v-model="dialog" max-width="900"> -->
                <!-- <v-card width="1500px"> -->
                    
                    <!-- <v-card-title> -->
                        <span class="ml-2 mt-3">MASTER LIST</span>
                        <v-spacer></v-spacer>
                        <!-- <v-icon dark @click="close()">mdi-close</v-icon> -->
                    <!-- </v-card-title> -->
                    <v-container fluid>
                        <v-card-text>
                            <v-text-field
                                v-model="search"
                                id="searchUser"
                                label="Search"
                                outlined
                                dense
                                placeholder="Enter keyword..."> 
                            </v-text-field>
                            <v-container fluid>
                                <v-toolbar flat height="10px"><v-spacer/>
                                    <v-btn
                                        class="overline mr-4 font-weight-bold"
                                        elevation="2"
                                        bottom
                                        dark
                                        color="#34495e" 
                                        @click="extractUser()">Extract
                                    </v-btn>
                                    <v-btn
                                        @click="showAddEmail()"
                                        dark
                                        elevation="2"
                                        fab
                                        bottom
                                        small  
                                        color="#34495e"        
                                        ><v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-toolbar><br>
                                <v-simple-table class="mainTable mt-2" fixed-header height="650px">
                                    <thead>
                                        <tr>
                                            <th style="width:90px;text-align:center;">ID</th>
                                            <th style="width:400px;text-align:center;">NAME</th>
                                            <th style="width:435px;text-align:center;">TYPE OF USERS</th>
                                            <th style="text-align:center;">BRANCH NAME</th>
                                            <th style="width:40px;text-align:center;">ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in  searchUsers" :key="index" v-show="item.name != 'guest'">
                                            <td> {{ item.user_id }} </td>
                                            <td style="text-align:center;"> {{ item.name }} </td>
                                            <!-- Type of Users -->
                                            <td class="font-weight-bold" style="text-align:center;"> 
                                                <v-chip v-show="item.is_admin == 1 && item.japan_admin != 1">Admin</v-chip>
                                                <v-chip v-show="item.is_special_account == 1 && item.japan_admin != 1">Special(Japan)</v-chip>
                                                <v-chip v-show="((item.is_gc_user == 1 || item.is_ichijo_user == 1 || item.is_rulebook_user) && item.japan_admin != 1)">Planner</v-chip>
                                                <v-chip v-show="item.is_hrd_requestor == 1">HRD Requestor</v-chip>
                                                <v-chip v-show="item.japan_admin == 1">Japan Admin</v-chip>
                                                <v-chip v-show="item.plan_control == 1">Plan Control</v-chip>
                                            </td>
                                            <td style="text-align:center;"> 
                                                <span v-if="item.branch_name">
                                                    {{ item.branch_name }}
                                                </span> 
                                                <span v-else>-</span>
                                            </td>
                                            <td style="text-align:center;">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                                        <v-btn
                                                            @click="showUpdateList(item)"
                                                            :disabled="loggedInUser.user_id != '39840' && loggedInUser.user_id != 'CRS2025'"
                                                            icon
                                                            small
                                                            v-on="on">
                                                            <v-icon color="primary">mdi-pencil</v-icon>
                                                        </v-btn>
                                                    </template>
                                                        <span>修正</span>
                                                </v-tooltip>
                                                    
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on}">
                                                        <v-btn
                                                            :disabled="loggedInUser.user_id != '39840' && loggedInUser.user_id != 'CRS2025'"
                                                            icon
                                                            small
                                                            v-on="on"
                                                            @click="deleteUserMaster(item)">
                                                            <v-icon color="#F44336">mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                        <span>消去</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table><br>
                            </v-container>
                            <span style="font-family:Arial;color:#808080;">Total User(s): {{ users.length }}</span>
                        </v-card-text>
                    </v-container>
                <!-- </v-card> -->
            <!-- </v-dialog> -->

            <!-- Add Dialog -->
            <v-dialog v-model="storeEmail" width="35%" persistent>
                <v-form id="StoreEmail" ref="StoreEmail" @submit.prevent="StoreEmail">
                    <v-card>
                        <v-card-title>
                            <span class="overline">ADD USER</span>
                            <v-spacer></v-spacer>
                            <v-icon dark @click="closeStoreEmail()">mdi-close</v-icon>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                type="text"
                                v-model="employee.user_id"
                                autofocus
                                label="User ID"
                                name="user_id"
                                prepend-icon="mdi-card-account-details"
                                required
                                outlined
                                dense
                                :rules="rules.required"
                                class="mt-4"
                            ></v-text-field>
                            <v-text-field
                                type="text"
                                v-model="employee.name"
                                label="Name"
                                name="name"
                                prepend-icon="mdi-account-circle"
                                required
                                outlined
                                dense
                                :rules="rules.required"
                            ></v-text-field>
                            <v-text-field
                                type="email"
                                v-model="employee.email"
                                @keyup="getEmployeeBranch(employee.email)"
                                label="Email"
                                name="email"
                                prepend-icon="mdi-account-circle"
                                required
                                outlined
                                dense
                                autocomplete="off"
                                :rules="[...rules.email, ...rules.required]"
                            ></v-text-field>
                            <v-text-field
                                v-model="userBranchName"
                                readonly
                                dense
                                outlined
                                label="Branch Name"
                                name="branch_name"
                                prepend-icon="mdi-account-circle">
                            </v-text-field>
                            <!-- <v-select
                                :items="usersAdmin"
                                label="Type of Users"
                                name="type_of_users"
                                prepend-icon="mdi-account-group"
                                outlined
                                dense
                            ></v-select> -->
                            <v-autocomplete
                                prepend-icon="mdi-account-group"
                                multiple
                                outlined
                                item-value="value"
                                item-text="text"
                                label="Type of Users"
                                :items="usersAdmin"
                                name="type_of_users"
                                chips
                                small-chips
                                deletable-chips
                            ></v-autocomplete>
                            <v-text-field
                                v-model="employee.password"
                                id="hiddenPassword"
                                dense
                                outlined
                                label="Password"
                                name="password"
                                prepend-icon="mdi-lock" 
                                :type="showPassword ? 'text' : 'password' "
                                :append-icon="showPassword ? 'mdi-eye': 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                required
                                :rules="minPassword"
                            ></v-text-field>
                            <v-text-field
                                v-model="employee.password_confirmation"
                                id="hiddenPassword"
                                dense
                                outlined
                                prepend-icon="mdi-lock"
                                label="Confirm Password"
                                :type="showPassword ? 'text' : 'password' "
                                :append-icon="showPassword ? 'mdi-eye': 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                :rules="rules.confirmpassword(employee.password_confirmation,employee.password)"
                            ></v-text-field>
                        </v-card-text>
                    
                <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn small color="info" type="submit" >
                        <v-icon left>mdi-lock</v-icon>
                        保存
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-form>

                <v-snackbar
                    v-model="snackbar.show"
                    :color="snackbar.color"
                    :timeout="timeout"
                    top
                    rounded="pill"
                    elevation="5"
                    min-width="0">
                    <v-icon>{{snackbar.icon}}</v-icon>
                    <strong>{{snackbar.message}}</strong>
                </v-snackbar>


            </v-dialog>

            <!-- Edit Dialog -->
            <v-dialog v-model="UpdateListDialog" width="35%" persistent>
                <v-form id="UpdateList" ref="UpdateList" @submit.prevent="UpdateList">
                    <v-card>
                        <v-card-title>
                            <span class="overline">UPDATE USER</span>
                            <v-spacer></v-spacer>
                            <v-icon dark @click="closeUpdateList()">mdi-close</v-icon>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                type="text"
                                v-model="tempData.user_id"
                                label="User ID"
                                name="user_id"
                                prepend-icon="mdi-card-account-details"
                                required
                                outlined
                                dense
                                :rules="rules.required"
                                class="mt-4"
                            ></v-text-field>
                            <v-text-field
                                type="text"
                                v-model="tempData.name"
                                label="Name"
                                name="name"
                                prepend-icon="mdi-account-circle"
                                required
                                outlined
                                dense
                                :rules="rules.required"
                            ></v-text-field>
                            <v-text-field
                                type="email"
                                v-model="tempData.email"
                                label="Email"
                                @keyup="getEmployeeBranch(tempData.email)"
                                name="email"
                                prepend-icon="mdi-account-circle"
                                required
                                outlined
                                dense
                                autocomplete="off"
                                :rules="[...rules.email, ...rules.required]"
                            ></v-text-field>
                            <v-text-field
                                v-model="tempData.branch_name"
                                readonly
                                dense
                                outlined
                                label="Branch Name"
                                name="branch_name"
                                prepend-icon="mdi-account-circle">
                            </v-text-field>
                            <!-- <v-select
                                v-model="tempData.is_admin"
                                :items="usersAdmin"
                                label="Type of Users"
                                name="type_of_users"
                                prepend-icon="mdi-account-group"
                                outlined
                                dense
                            ></v-select> -->
                            <v-autocomplete
                                v-model="typeOf"
                                :items="usersAdmin"
                                prepend-icon="mdi-account-group"
                                multiple
                                outlined
                                item-value="value"
                                item-text="text"
                                label="Type of Users"
                                name="type_of_users"
                                chips
                                small-chips
                                class="font-weight-bold"
                                deletable-chips>
                            </v-autocomplete>
                            <v-text-field
                                v-model="oldPassword"
                                dense
                                outlined
                                label="Old Password"
                                name="old_password"
                                prepend-icon="mdi-lock" 
                                type="password"
                                
                                required
                                :rules="minPassword">
                            </v-text-field>
                            <v-text-field
                                v-model="updatePassword"
                                dense
                                outlined
                                label="New Password"
                                name="new_password"
                                prepend-icon="mdi-lock" 
                                :type="showPassword ? 'text' : 'password' "
                                :append-icon="showPassword ? 'mdi-eye': 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                required
                                :rules="minPassword">
                            </v-text-field>
                            <v-text-field
                                v-model="updatePasswordConfirmation"
                                dense
                                outlined
                                prepend-icon="mdi-lock"
                                label="Confirm Password"
                                :type="showPassword ? 'text' : 'password' "
                                :append-icon="showPassword ? 'mdi-eye': 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                :rules="rules.confirmpassword(updatePasswordConfirmation,updatePassword)">
                            </v-text-field>
                        </v-card-text>
                    
                <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn small color="info" type="submit">
                        <v-icon left>mdi-lock</v-icon>
                        保存
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>

            <v-dialog v-model="deleteUserDialog" width="19%" persistent>
                <v-form id="DeleteUser" ref="DeleteUser" @submit.prevent="DeleteUser">
                    <v-card>
                        <v-card-title>
                            <span class="overline">DELETE USER</span>
                        </v-card-title><v-spacer/>
                        <v-card-text>
                            Are you sure you want to delete <b>{{ tempData.user_id }} - {{ tempData.name }}</b>&nbsp;?
                        </v-card-text>
                        <input type="hidden" :value="tempData.id" name="id">
                        <input type="hidden" :value="tempData.name" name="name">
                        <v-card-actions><v-spacer/>
                            <v-btn type="submit" color="success" dark depressed width="105px">Yes</v-btn>
                            <v-btn @click="closetDeleteUser()" depressed color="#E74C3C" class="white--text" width="105px">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </div>
        <!-- NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28) -->
        <!-- SYSTEM UNDERMAINTENANCE MESSAGE -->
        <div v-if="isUnderMaintenance == 2" class="centered-div">
            <v-card height="300px" width="800px" elevation="0">
                <v-card-text class="d-flex justify-center align-center" style="height: 100%;">
                    <div class="text-center">
                        <h1 style="color: #A6AEBF">システムメンテナンス中</h1>
                        <br />
                        <h1 style="color: #A6AEBF" class="ma-3">下記時間帯はシステムの使用ができません。</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">{{japanDate}} {{japanTime}}（日本時間）</h1>
                        <h1 style="color: #A6AEBF" class="ma-3">※{{philippineTime}}（フィリピン時間）</h1>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import md5 from 'js-md5'
import axios from 'axios';
import downloadCsv from 'download-csv';
export default {

    computed : {
            ...mapState([
                'rules',
                'loggedInUser'
            ]),

        searchUsers(){
            return this.users.filter((data) => {
                let searchData = new RegExp(this.search.toUpperCase(), "g");
                return JSON.stringify(Object.values(data)).toUpperCase().match(searchData);
            });
        }
    },

    props: {
        dialog: Boolean
    },

    data: () => ({
        isUnderMaintenance: null,
        japanDate: '',
        japanTime: '',
        philippineTime: '',
        overlay: false,
        status: '',
        search : '',
        users: [],
        employee : {},
        tempData : {},
        typeOf : [],

        typesOfUsers : null,
        oldPassword : '12345',
        updatePassword : '',
        updatePasswordConfirmation : '',
        userBranchName : '',

        // Dialog
        storeEmail : false,
        UpdateListDialog : false,
        deleteUserDialog : false,
        showPassword : false,
        disableBtn: false,

        snackbar : {
                show: false,
                message : null,
                color : null,
            },
            timeout:1200,

        minPassword: [
            (v) => (v || "").length >= 4 ||"Must contain atlest 4 characters.",
        ],

        usersAdmin: [
            {text:'Admin', value:'Admin'},
            // {text:'Special', value:'Special'},
            {text:'Planner', value:'Planner'},
            {text:'HRD Requestor', value:'HRD Requestor'},
            {text:'Japan Admin', value:'Japan Admin'},
            {text:'Plan Control', value:'Plan Control'},
            // {text:'HRD Viewer', value:'HRD Viewer'},
        ],

        branchName : [],
        env: {
            response: process.env.MIX_ENV == "local" ? "response-local" : "response",
            request: process.env.MIX_ENV == "local" ? "request-local" : "request",
        },


    }),

    sockets: {
        // NOTE : SOCKET 
        updateReceived: async function(socket) {
            if(socket && socket.dispatchType == this.env.response && socket.functionType == 'employee-branch' && socket.uniqId == this.loggedInUser.uniqId){
                if(socket.data.branch){
                    if(this.status == 'EDIT') this.tempData.branch_name = socket.data.branch;
                    else if(this.status == 'ADD') this.userBranchName = socket.data.branch;
                }else{
                    if(this.status == 'EDIT') this.tempData.branch_name = null;
                    else if(this.status == 'ADD') this.userBranchName = null;
                }
            }
        }
    },


    methods: {
        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async getSytemMaintenanceDatetime(){
            await axios({
                method: 'get',
                url: 'api/system_maintenance_datetime'
            }).then(({data}) => {
                this.isUnderMaintenance = data[0].is_undermaintenance;
                this.japanDate = data[0].japan_date;
                this.japanTime = data[0].japan_time;
                this.philippineTime = data[0].ph_time;
            })
        },

        async getEmployeeBranch(email){
            if(/^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test(email)){
                try {
                    await this.$socket.emit('newUpdate', {
                        dispatchType: this.env.request,
                        data: {
                            emp_email: email,
                            uniqId: this.$store.state.loggedInUser.uniqId
                        },
                        functionType: 'employee-branch'
                    });
                } catch (error) {
                    console.log(error, 'socket error');
                }
            }
        },
        extractUser(){
            console.log('test')
            axios({
                method : 'post',
                url : 'api/extractUserId',
            }).then((res) => {
                // console.log(res.data,'res')
                let columns = {
                    user_id : "USER ID",
                    name : "NAME",
                    email : "EMAIL",
                    branch_name : "BRANCH NAME"
                }
                downloadCsv(res.data,columns, 'MasterList')
            })
        },


        getBranchName(){
            axios({
                post : 'get',
                url : 'api/getBranch'
            }).then((res) => {
                res.data.filter((v) => {
                    if(this.employee.email == v.MailAddress){
                        this.userBranchName = v.ContractExhibitionName
                        // console.log(this.userBranchName,'this.userBranchName')
                        // console.log(v.ContractExhibitionName)
                        // return this.employee.branch_name = v.ContractExhibitionName;
                    } 
                })
            })
        },

        closeStoreEmail(){
            this.storeEmail = false;
            this.$refs.StoreEmail.reset();
            this.$refs.StoreEmail.resetValidation();
        },

        closeUpdateList(){
            this.$refs.UpdateList.reset();
            this.$refs.UpdateList.resetValidation();
            this.UpdateListDialog = false;
        },

        closetDeleteUser(){
            this.deleteUserDialog = false;
        },

        showUpdateList(item){
            this.status = 'EDIT';
            console.log(item,'item')
            this.tempData = {...item};
            this.oldPassword = '12345',
            this.UpdateListDialog = true;

            if(item.is_admin == 1){
                this.typeOf.push({text:'Admin', value:'Admin'});
            }

            if(item.is_gc_user == 1 || item.is_ichijo_user == 1 || item.is_rulebook_user){
                this.typeOf.push({text:'Planner', value:'Planner'})
            }

            if(item.is_special_account == 1){
                this.typeOf.push({text:'Special', value:'Special'})
            }

            if(item.is_hrd_requestor == 1){
                this.typeOf.push({text:'HRD Requestor', value:'HRD Requestor'})
            }

            if(item.japan_admin == 1){
                this.typeOf.push({text:'Japan Admin', value:'Japan Admin'})
            }

            if(item.plan_control == 1){
                this.typeOf.push({text:'Plan Control', value:'Plan Control'})
            }

        },

        showAddEmail(){
            this.storeEmail = true;
            this.status = 'ADD';
        },

        close(){
            this.toggleDialogMasterList(false)
        },

        toggleDialogMasterList(val){
            this.$emit('toggleDialogMasterList', val)
        },

        getUsers(){
            this.overlay = true;
            axios({
                method : 'post',
                url : 'api/get_users'
            }).then( (res) => {
                // console.log(res.data)
                this.users = res.data
                this.overlay = false;
            })
        },

        toggleUpdateDialog(item){
                if(item){
                    // this.tempData = {...item};
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

        
        StoreEmail(){
            axios({
                method : 'post',
                url : 'api/getUsersID',
                data : {
                    userID : this.employee.user_id,
                    email : this.employee.email,
                    // name : this.employee.name,
                }
            }).then( (res) => {
                // console.log(res.data,'datassssss')
                // this.users = res.data
                if(res.data.length > 0){
                    this.snackbar = {
                        message : 'User/Email Already Exist !!',
                        color : 'red',
                        icon: 'mdi-information',
                        show: true
                    }
                    this.employee.user_id = '',
                    this.employee.name = '',
                    this.employee.email = '',
                    this.employee.password = '',
                    this.employee.password_confirmation = ''

                    // console.log('MERON NA')
                } else {
                    if(this.$refs.StoreEmail.validate()){
                        const myForm = document.getElementById('StoreEmail');
                        const formdata = new FormData(myForm);

                        axios({
                            method : "POST",
                            url : 'api/get_users/register',
                            data: formdata,
                            config: {
                                headers: { "Content-Type": "multipart/form-data" },
                            },
                        })
                        .then((res) => {
                            this.closeStoreEmail();
                            this.disableBtn = false
                            this.getUsers();
                            // console.log(res.data,'data')
                        })
                        .catch(err =>{
                            this.disableBtn = false
                            // console.log(err)
                            alert('Something Went Wrong')
                        })
                    }
                }
            })
        },

        UpdateList(){    
            if(this.$refs.UpdateList.validate()){
                const myForm = document.getElementById('UpdateList');
                const formdata = new FormData(myForm);
                formdata.append('id',this.tempData.id)

                axios({
                    method : "POST",
                    url : `/api/get_users/update`,
                    data: formdata,
                    // config: {
                    //     headers: { "Content-Type": "multipart/form-data" },
                    // },
                }) .then((res) => {
                    this.closeUpdateList();
                    this.getUsers();
                    console.log(res.data,'data')
                })
                // .catch(err =>{
                //     this.disableBtn = false
                //     // console.log(err)
                //     alert('Something Went Wrong')
                // })
            }
        },

        DeleteUser(){
            if(this.$refs.DeleteUser.validate()){
                const myForm = document.getElementById('DeleteUser')
                const formdata = new FormData(myForm)

                axios({
                    method : 'post',
                    url : 'api/get_users/deleterecord',
                    data : formdata
                }).then( () => {
                    this.getUsers();
                    this.closetDeleteUser();
                    this.getUsers();
                })
            }
        },

        deleteUserMaster(userID){
            this.tempData.id = userID.id;
            this.tempData.user_id = userID.user_id;
            this.tempData.name = userID.name;
            this.deleteUserDialog = true;
        },

    },

    mounted() {
        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        this.getSytemMaintenanceDatetime();

        this.getUsers();
    },
}
</script>
<style scoped>
.centered-div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>